import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartaoBi } from 'app/resources/bi/cartao.bi';
import { ResponseVoucherInvalidoBi } from 'app/resources/bi/responseVoucherInvalido.bi';
import { TransferenciaBi } from 'app/resources/bi/transferencia.bi';
import { VoucherBi } from 'app/resources/bi/voucher.bi';
import { Cartao } from 'app/resources/classes/cartao';
import { ResponseVoucherInvalido } from 'app/resources/classes/responseVoucherInvalido';
import { Rotas } from 'app/resources/classes/rotas';
import { VouchersParaConta } from 'app/resources/classes/vouchersParaConta';
import { HttpService } from 'app/resources/services';
import { AlertService } from 'app/resources/services/alert.service';
import { VoucherService } from 'app/resources/services/voucher.service';
import { MoedaUtils } from 'app/resources/utils/moeda-utils'

@Component({
  selector: 'app-voucher-resgatar',
  templateUrl: './voucher-resgatar.component.html'
})
export class VoucherResgatarComponent implements OnInit {

  public pontosTarifa: number;
  public indiceMoeda: number;
  public voucherAdicional: Cartao;
  public vouchersInvalidos: Array<ResponseVoucherInvalido>;

  constructor(public voucherService: VoucherService, private router: Router, private httpService: HttpService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.vouchersInvalidos = [];
    if (this.voucherService.vouchersAdicionais === undefined) {
      this.voucherService.vouchersAdicionais = [];
    }
    this.atualizaPontosTarifa();
    this.atualizaIndiceMoeda();
  }

  private atualizaPontosTarifa(): void {
    new TransferenciaBi.Rest(this.httpService).getTransferenciaBancariaTarifa()
      .subscribe(
        success => {
          this.pontosTarifa = success.json();
        },
        error => {
          this.alertService.errorAlert(error._body);
        }
      );
  }

  private atualizaIndiceMoeda(): void {
    new CartaoBi.Rest(this.httpService).getIndiceConversaoMoeda()
      .subscribe(
        success => {
          this.indiceMoeda = success.json();
        },
        error => {
          this.alertService.errorAlert(error._body);
        }
      );
  }

  public irParaTelaVoucherConfirmar(): void {
    this.router.navigate([Rotas.VOUCHER_CONFIRMAR]);
  }

  public getValorTotalPontos(): number {
    let valorTotalPontos: number;
    valorTotalPontos = this.voucherService.voucherPrincipal.getSaldoPontos();
    if (this.voucherService.vouchersAdicionais.length > 0) {
      for (const voucher of this.voucherService.vouchersAdicionais) {
        valorTotalPontos = (parseInt(valorTotalPontos.toString(), 10) + parseInt(voucher.getSaldoPontos().toString(), 10));
      }
    }
    return valorTotalPontos;
  }

  public getValorLiquido(): number {
    const valorTarifa = MoedaUtils.pontoToMoeda(this.pontosTarifa, this.indiceMoeda);
    const valorTotal = MoedaUtils.pontoToMoeda(this.getValorTotalPontos(), this.indiceMoeda);
    const valorLiquido = valorTotal - valorTarifa;
    return valorLiquido;
  }

  public abrirModalAdicionarVoucher(): void {
    this.voucherAdicional = new Cartao();
  }

  public inserirVoucherAdicional(event: Event): void {
    event.preventDefault();
    if (document.getElementById('btn-modal-fechar')) {
      document.getElementById('btn-modal-fechar').click();
    } else if (document.getElementById('btn-bootbox-close')) {
      document.getElementById('btn-bootbox-close').click();
    }
    this.voucherService.vouchersAdicionais.push(this.voucherAdicional);
  }

  public validarVouchers(): void {
    this.vouchersInvalidos = undefined;
    let vouchersParaValidacao: Array<Cartao> = [];
    if (this.voucherService.vouchersAdicionais.length > 0) {
      const clone: Array<Cartao> = [];
      vouchersParaValidacao = Object.assign(clone, this.voucherService.vouchersAdicionais);
    }
    vouchersParaValidacao.push(this.voucherService.voucherPrincipal);
    new VoucherBi.Rest(this.httpService).validar(new VouchersParaConta(vouchersParaValidacao)).subscribe(
      success => {
        this.vouchersInvalidos = ResponseVoucherInvalidoBi.Parser.fillList(success.json());
        if (this.vouchersInvalidos.length === 0) {
          this.irParaTelaDadosTransferencia();
        } else if (this.vouchersInvalidos.length === 1) {
          this.alertService.errorAlert('Existe um Voucher inválido na solicitação!\n'
            + 'Por favor, revise as informações e tente novamente.');
        } else if (this.vouchersInvalidos.length > 1) {
          this.alertService.errorAlert('Existem Vouchers inválidos na solicitação!\n' +
            'Por favor, revise as informações e tente novamente.');
        }
      },
      error => {
        this.alertService.errorAlert(error._body);
        this.vouchersInvalidos = [];
      }
    );
  }

  public isVoucherInvalido(voucher: Cartao): boolean {
    const invalido = false;
    if (this.vouchersInvalidos.length > 0) {
      for (const voucherInvalido of this.vouchersInvalidos) {
        if (voucher.getNumero().trim() === voucherInvalido.getCartao().getNumero().trim()) {
          return !voucherInvalido.getCartao().isDocumentoValido();
        }
      }
    }
    return invalido;
  }

  public getMensagemInconsistencia(voucher: Cartao): string {
    if (this.vouchersInvalidos.length > 0) {
      for (const voucherInvalido of this.vouchersInvalidos) {
        if (voucher.getNumero().trim() === voucherInvalido.getCartao().getNumero().trim()) {
          return voucherInvalido.getInconsistencia();
        }
      }
    }
  }

  private irParaTelaDadosTransferencia(): void {
    this.router.navigate([Rotas.VOUCHER_DADOS_TRANSFERENCIA]);
  }
}




// WEBPACK FOOTER //
// ./src/app/voucher/voucher-resgatar/voucher-resgatar.component.ts